export default __webpack_public_path__ + "static/media/icon_4_1.f8a3b107.svg";